import LOCALS from 'commons/locals';
import { FormLabel } from '../../form-label';
import i18n from 'i18n';
import {
  Control,
  Controller,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { Select } from 'antd';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { SelectOption } from 'types/base';
import { useCallback, useMemo } from 'react';
import { generateRankDesc } from 'pages/product/create-page-v2/common';

const Rank = ({
  control,
  index,
  setValue,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  setValue: UseFormSetValue<CreateRecyclingConsignmentOrderV2SchemaType>;
}) => {
  const { rankSelectOptions } = useAppSelector(selectGlobalInfo);

  const rankListSort = useMemo((): SelectOption[] => {
    if (rankSelectOptions && rankSelectOptions.length) {
      return [...rankSelectOptions].sort(
        (a: SelectOption, b: SelectOption) => b.sort! - a.sort!
      );
    }
    return [];
  }, [rankSelectOptions]);

  const SelectFilter = useCallback(
    (input: string, option: SelectOption | undefined) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    []
  );

  const selectedRankDescOptions = useWatch({
    control,
    name: `productList.${index}.selectedRankDescOptions`,
  });

  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.rank)}:</FormLabel>
      <Controller
        name={`productList.${index}.rank`}
        control={control}
        render={({ field, formState: { errors } }) => (
          <div className="relative w-full">
            <Select
              status={errors.productList?.[index]?.rank ? 'error' : undefined}
              {...field}
              options={rankListSort}
              className="w-full"
              placeholder={i18n.t(LOCALS.please_select) || ''}
              filterOption={SelectFilter}
              showSearch
              onChange={(value) => {
                field.onChange(value);

                setValue(
                  `productList.${index}.rankDesc`,
                  generateRankDesc({
                    selectedRankDescOptions,
                    rank: value,
                    rankSelectOptions,
                  })
                );
              }}
            />
          </div>
        )}
      />
    </div>
  );
};

export default Rank;
